export default __webpack_public_path__ + "static/media/home-decor-img-18.598f0ca9.jpg";